module.exports = __webpack_public_path__ + "img/f6.5b2ac2f8.jpg";